import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {GlobalQuest} from '@/app/core/models/battlepeps/globalQuest';

@Injectable({
	providedIn: 'root'
})
export class GlobalQuestService {

	private readonly SERVICE_URI = `${environment.backendUrl}/battlepeps`;

	constructor(
		private readonly http: HttpClient
	) {}

	/** Quêtes globales en cours (ACTIVE) de la saison BattlePeps active. */
	getCurrent(): Observable<GlobalQuest[]> {
		return this.http.get<GlobalQuest[]>(`${this.SERVICE_URI}/current/global-quests`);
	}
}
